// @flow
import React, { Component } from 'react';
import ExternalLink from './ExternalLink';
// $FlowFixMe
import { ReactComponent as ExtLinkIcon } from '../assets/icons/ext-link.svg';

type Props = {|
  to: string
|};

export default class KnowledgeBaseLink extends Component<Props> {
  render() {
    const { to, ...rest } = this.props;
    return (
      <ExternalLink
        {...rest}
        href={`https://merchant-support.net-cents.com/knowledge${to}`}
      >
        Knowledge Base
        <ExtLinkIcon />
      </ExternalLink>
    );
  }
}
